// button height + padding
export const TABS_HEIGHT =
  "calc(var(--chakra-space-11) + (2 * var(--chakra-space-2-5)))"
// size: sm button height + padding
export const TABS_HEIGHT_SM =
  "calc(var(--chakra-space-8) + (2 * var(--chakra-space-2-5)))"

export const TABS_SM_BUTTONS_STYLES =
  "#tabs .chakra-button:not(.chakra-menu__menu-button) {height: var(--chakra-space-8); font-size: var(--chakra-fontSizes-sm); border-radius: var(--chakra-radii-lg); padding: 0 var(--chakra-space-3)}"
